import * as ActionTypes from "constants/ActionTypes";
import { combineReducers } from "redux";

function adTransitionCount(state = 0, action) {
  switch (action.type) {
    case ActionTypes.INCREMENT_AD_TRANSITIONS:
      return state + 1;
    case ActionTypes.RESET_ADS:
      return 0;
    default:
      return state;
  }
}

function adCompleted(state = false, action) {
  switch (action.type) {
    case ActionTypes.AD_COMPLETED:
      return true;
    case ActionTypes.RESET_ADS:
      return false;
    default:
      return state;
  }
}

function adLoaded(state = false, action) {
  switch (action.type) {
    case ActionTypes.SET_AD_LOADED:
      return true;
    case ActionTypes.RESET_ADS:
      return false;
    default:
      return state;
  }
}

function numberOfAdsPlayed(state = 0, action) {
  switch (action.type) {
    case ActionTypes.AD_COMPLETED:
      return state + 1;
    default:
      return state;
  }
}

function adDuration(state = Number.MAX_SAFE_INTEGER, action) {
  switch (action.type) {
    case ActionTypes.SET_AD_DURATION:
      return action.value;
    case ActionTypes.RESET_ADS:
      return Number.MAX_SAFE_INTEGER;
    default:
      return state;
  }
}

function adPlaying(state = false, action) {
  switch (action.type) {
    case ActionTypes.SET_AD_PLAYING:
      return action.value;
    case ActionTypes.RESET_ADS:
      return false;
    default:
      return state;
  }
}

function isReadyForAdReset(state = false, action) {
  switch (action.type) {
    case ActionTypes.SET_IS_READY_FOR_AD_RESET:
      return true;
    case ActionTypes.RESET_ADS:
      return false;
    default:
      return state;
  }
}

function isSkipAllowedNow(state = false, action) {
  switch (action.type) {
    case ActionTypes.SET_AD_SKIP_ALLOWED_NOW:
      return action.value;
    case ActionTypes.RESET_ADS:
      return false;
    default:
      return state;
  }
}

function isSkippable(state = false, action) {
  switch (action.type) {
    case ActionTypes.SET_AD_IS_SKIPPABLE:
      return action.value;
    case ActionTypes.SET_AD_SKIP_ALLOWED_NOW:
      return true;
    case ActionTypes.RESET_ADS:
      return false;
    default:
      return state;
  }
}

function userRequestedAdSkip(state = false, action) {
  switch (action.type) {
    case ActionTypes.USER_REQUESTED_AD_SKIP:
      return true;
    case ActionTypes.AD_COMPLETED:
    case ActionTypes.SET_AD_IS_SKIPPABLE:
    case ActionTypes.SET_AD_PLAYING:
    case ActionTypes.SET_AD_SKIP_ALLOWED_NOW:
      return false;
    case ActionTypes.RESET_ADS:
      return false;
    default:
      return state;
  }
}

export default combineReducers({
  adCompleted,
  adDuration,
  adLoaded,
  adPlaying,
  adTransitionCount,
  isReadyForAdReset,
  isSkipAllowedNow,
  isSkippable,
  numberOfAdsPlayed,
  userRequestedAdSkip,
});
